import styled from "styled-components";

export const MediaContainer = styled.div`
  display: grid;
  grid-template-columns: auto auto auto;
  width: 80%;
  gap: 1rem;
  margin: auto;
  margin-top: 3rem;
  margin-bottom: 1rem;
  @media (width<=768px) {
    grid-template-columns: auto;
  }
`;

export const MediaCardContainer = styled.section`
  width: 100%;
  height: 500px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0;
  justify-content: center;
  border: 1px solid black;
  color: #101e8e;
  background: #fff;
  div {
    img {
      width: 100%;
      object-fit: contain;
      height: 60%;
    }
    iframe {
      width: 100%;
      height: 60% !important;
    }
  }
`;

export const ViewContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  width: 720px;
  color: #101e8e;
  background: #fff;
  @media (width<=768px) {
    width: 80%;
    height: fit-content;
    padding: 1rem 0 1rem 1rem;
  }
`;
